// MIT License - Copyright (c) 2026 Doug McNall

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { MarvelAliensPlanets } from './AliensConfig';

export const universeMarvel = {
  id: 'marvel',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: MarvelAliensPlanets
};

export default universeMarvel;
